// Authentication Types

/**
 * Login credentials interface
 */
export interface LoginCredentials {
  email: string;
  password: string;
}

/**
 * Update password request interface
 */
export interface UpdatePasswordRequest {
  email: string;
  otp: string;
  newPassword: string;
}

/**
 * User information interface
 */
export interface User {
  name: string;
  email: string;
  department: string;
  numberDocument: string | null;
  isFirstAccess: boolean;
}

/**
 * Authentication response from login API
 */
export interface AuthResponse {
  accessToken: string;
  expiresIn: number;
  refreshToken: string;
  refreshExpiresIn: number;
}

/**
 * Token storage keys
 */
export const AUTH_STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  EXPIRES_AT: 'expires_at',
} as const;

/**
 * Authentication error types
 */
export type AuthErrorType =
  | 'invalid_credentials'
  | 'account_locked'
  | 'email_not_verified'
  | 'network_error'
  | 'server_error';

/**
 * Authentication error interface
 */
export interface AuthError {
  type: AuthErrorType;
  message: string;
}
